import "./index.css";

// ----------------------------------------------------------------------
// import { ProgressBarStyle } from '@components/ProgressBar'; // TODO: fix this
import ScrollToTop from "@components/ScrollToTop";
import MotionLazyContainer from "@components/animate/MotionLazyContainer";
import ErrorPage from "./ErrorPage";
import { useSelector } from "@redux/store";
import Router from "./routes";
import { SnackbarProvider } from "notistack";
import "simplebar-react/dist/simplebar.min.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { atom, useRecoilState } from "recoil";

// ----------------------------------------------------------------------
const fallbackComponent = <ErrorPage />;
// ----------------------------------------------------------------------


export const countAtom = atom({
  key: "atomkey",
  default: [],
});

export const FilterAtom = atom<string[]>({
  key: 'filteratom',
  default: [],
});

export const countAtomBool = atom({
  key: "atomkeybool",
  default: false,
});

function App() {
  const { hasError } = useSelector((s) => s.app);

  if (hasError) return fallbackComponent;

  return (
    <MotionLazyContainer>
      <SnackbarProvider />
      {/* <ProgressBarStyle /> */}
      <ScrollToTop />
      <Router />
    </MotionLazyContainer>
  );
}

export default App;
